export default "__VITE_ASSET__BewLz1Rs__"